import { createSlice } from '@reduxjs/toolkit';
import { WebStorageClient } from "../clients/webStorage.client";
const [from, to] = WebStorageClient.getAlertsDateFilters({ forReducer: true });

const initialState = {
  from,
  to
};

const actionsDateFiltersSlice = createSlice({
  name: 'actionsDateFilters',
  initialState,
  reducers: {
    setActionsFrom(state, action) {
      state.from = action.payload;
    },
    setActionsTo(state, action) {
      state.to = action.payload;
    },
  },
});

export const { setActionsFrom, setActionsTo } = actionsDateFiltersSlice.actions;

export default actionsDateFiltersSlice.reducer;
